<div class="responsiveBackground" *ngIf="loginFormVisible"></div>
<iframe
  *ngIf="loginFormVisible"
  allow="autoplay;"
  src="https://player.vimeo.com/video/369278635?loop=1&autoplay=1&background=1&title=0&byline=0&portrait=0&player_id=iframe40679&controls=0"
  data-ready="true"
  class="video-background"
>
</iframe>

<div class="form-container-style">
  <form *ngIf="loginFormVisible" action="your-action" class="form-style">
    <dx-form
      [readOnly]="false"
      [showColonAfterLabel]="true"
      [showValidationSummary]="true"
      validationGroup="customerData"
    >
      <dxi-item itemType="group" class="logo-login-page-container">
        <img [src]="logoUrl" class="logo-style" />
      </dxi-item>

      <dxi-item itemtype="simple">
        <div *dxTemplate>
          <span i18n="@@welcome">Welcome to the</span> {{ environmentName }}
          <span i18n="@@platform">Platform.</span>
        </div>
      </dxi-item>

      <dxi-item itemType="group" [colSpan]="1">
        <dx-button
          horizontalAlignment="center"
          class="dx-button-mode-contained gt-primary-center gpd-prim"
          i18n-text="@@loginWithMicrosoftAccount"
          text="LOGIN WITH MICROSOFT ACCOUNT"
          icon="key"
          (onClick)="attemptLogin()"
        >
        </dx-button>
      </dxi-item>
    </dx-form>
  </form>
  <form *ngIf="!loginFormVisible" action="your-action" class="form-style">
    <dx-form [readOnly]="true">
      <dxi-item itemType="group" class="logo-login-page-container">
        <!-- <img src="/assets/images/branding/logo.png" class="logo-style" /> -->
      </dxi-item>

      <dxi-item itemtype="simple">
        <div *dxTemplate>
          Please wait while we check the status of your authentication ...
        </div>
      </dxi-item>
    </dx-form>
  </form>
</div>
